import {IProduct} from 'modules/product-card/models/ProductResponse';
import {getWineshopsForTodayPickup, getWineshopsWithStock} from 'modules/wineshops-list/helpers';
import {useWineshopList} from 'modules/wineshops-list/hooks/useWineshopList';
import {useMemo} from 'react';

export const useWineshopsForTodayWithStock = (productData: IProduct | null) => {
    const wineshopList = useWineshopList();

    return useMemo(() => {
        if (!productData) {
            return [];
        }

        const wineshopsForTodayList = getWineshopsForTodayPickup(wineshopList);

        return getWineshopsWithStock(productData, wineshopsForTodayList);
    }, [productData, wineshopList]);
};
